export default __webpack_public_path__ + "static/media/BlueCheck.5dd1abb4.svg";